import { AnyAction } from 'redux';
import { GroupActionTypes } from '../actions/groups';

const initialState = {
  groups: []
};

export function GroupsReducer(state = initialState, action: AnyAction) {
  if (!state) {
    return initialState;
  }

  switch (action.type) {
    case GroupActionTypes.FETCH_USER_GROUPS:
      return {
        ...state,
        groups: action.payload
      };

    default:
      return state;
  }
}
